'use es6';

import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import HelpText from './HelpText';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingContainer = ({
  displayHelpText
}) => {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    position: "absolute",
    inlineSize: "100%",
    blockSize: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(View, {
      as: "div",
      textAlign: "center",
      blockSize: "50px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        layout: "centered",
        showLabel: displayHelpText,
        label: HelpText
      })
    })
  });
};
export default LoadingContainer;